<template>
	<div class="body-mid">
		<div style="background: #E5EDFB;">
			<div style="display: inline-block; font-size: 18px;font-weight: bold;line-height: 40px;color: white;
			padding: 0 20px;height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;">
				个人账号设置
			</div>
		</div>
		<div style="padding: 30px; box-sizing: border-box;" v-if='userInfo.id'>
			<div class="Avatar">
				<div class="userAvatar">
					<div style="width: 106px;height: 106px;overflow: hidden;border-radius: 50%;"
						v-if='isDataString(userInfo.avatar)'>
						<img style="width: 100%;height: 100%;" :src="userInfo.avatar" alt="">
					</div>
					<div style="width: 106px;height: 106px;overflow: hidden;border-radius: 50%;" v-else>
						<img style="width: 100%;height: 100%;" :src="getImgSrc(userInfo.avatar)" alt="">
					</div>
					<div><el-upload class="upload-demo" :headers='{token:$store.state.userInfo.token}'
							:action="uploadPath+'common/upload'" :show-file-list='false' :on-success='uploadAvatar'
							accept='.png,.jpg' :file-list="fileList">
							<div class="upload">本地上传</div>
						</el-upload></div>
				</div>
				<div class="systeamAvatar">
					<p>请选择一个头像:</p>
					<div style="margin-top: 25px;display: flex;justify-content:flex-start;flex-wrap: wrap;">
						<div style="margin-bottom: 15px;margin-right: 25px;width: 58px;height: 58px;
							overflow: hidden;border-radius: 50%;cursor: pointer;
						" v-for="(item,index) in avatars" @click="changeAvatar(item)">
							<img :src='getImgSrc(item.image)' style="width: 100%;height: 100%;" alt="">
						</div>
					</div>
				</div>
			</div>
			<div class="secureStatus">
				<div class="form-item" style="">
					<div class="title">用户安全状态：</div>
					<div style="display: flex;align-items: center;">
						<div style="width: 650px;margin: 0 40px;"><el-progress :show-text="false" :stroke-width="15"
								color="#0052D9"
								:percentage="getSafeLevel>0? safeLevel*getSafeLevel:safeLevel"></el-progress></div>
						<div style="flex: 1;">
							<p style="margin-left: 50px;color: #888;display: flex;text-align: center;">

							<p  style="color: red;text-align: center;font-size: 14px;" v-for="(item,index) in safeTips">
								{{item}}</p>
							</p>
						</div>
					</div>
				</div>
			</div>
			<div class="form">
				<div class="form-item" style="">
					<div class="title">修改昵称：</div>
					<div class="inp" style="flex: 1;">
						<div style=" display: flex;justify-content: space-between;align-items: center;">
							<input type="text" v-model="oldNickName" placeholder="请输入昵称">
							<span style="color: #0052D9;cursor: pointer;margin-right: 40px;"
								@click='editNickname'>确认修改</span>
						</div>
					</div>
				</div>
				<div class="form-item" style="align-items: baseline;">
					<div class="title">修改密码：</div>
					<div class="inp" style="flex: 1;">
						<div style=" ">
							<div style="margin-bottom: 30px;"><input type="password" placeholder="请输入当前密码"
									v-model.trim="oldPassword"></div>
							<div style="margin-bottom: 30px;"><input type="password" v-model.trim="newPassword"
									placeholder="请输入新密码"></div>
							<div style="margin-bottom: 30px;
								display: flex;justify-content: space-between;align-items: center;
							"><input type="password" placeholder="请再次输入新密码" v-model.trim="reNewPassword">
								<span style="color: #0052D9;cursor: pointer;margin-right: 40px;"
									@click="editUserPassword">确认修改</span>
							</div>
						</div>
					</div>
				</div>
				<h3 style="margin-bottom: 20px;">主要联系方式</h3>
				<div class="form-item" style="align-items: flex-start;">
					<div class="title" style="line-height: 45px;">
						<div style="width: 113px;"> 修改邮箱：</div>
					</div>
					<div class="inp">
						<div style="display: flex;">
							<input type="text" v-model="form2.email" :placeholder="getOriginal('email')">
							<div style="margin-left: 30px;display: flex;align-items: ;">
								<span style="line-height: 45px;">验证码:</span>
								<input type="text" style="width: 100px;margin-left: 10px;" v-model="form2.emailCode"
									placeholder="验证码">
								<p class="getCode" @click="send" v-if="showtime===null">获取邮箱验证码</p>
								<p v-else class="getCode"> {{showtime}}</p>
								<span style="color: #0052D9;cursor: pointer;margin-left: 27px;line-height: 45px;"
									@click='editMainEmail'>确认修改</span>
							</div>
						</div>
					</div>
				</div>
				<div class="form-item" style="align-items: flex-start;">
					<div class="title" style="line-height: 45px;">
						<div style="width: 113px;"> 微信号：</div>
					</div>
					<div class="inp">
						<div style="display: flex;" class="wechat">
							<div @click="wechatLogin" v-if="!userInfo.open_id || userInfo.open_id === ''" style="background-color: #0052D9;color: white;">绑定微信号</div>
							<div @click="delOpenId" v-if="userInfo.open_id" style="background-color: #0052D9;color: white;">解绑微信号</div>
						</div>
					</div>
				</div>
				<!-- <div class="form-item" style="align-items: flex-start;">
					<div class="title" style="line-height: 45px;">
						<div style="width: 113px;"> 支付宝：</div>
					</div>
					<div class="inp">
						<div style="display: flex;" class="wechat">
							<div @click="aliLogin" v-if="!userInfo.alipay_user_id || userInfo.alipay_user_id == ''" style="background-color: #0052D9;color: white;">绑定支付宝</div>
							<div @click="delAliId" v-if="userInfo.alipay_user_id" style="background-color: #0052D9;color: white;">解绑支付宝</div>
						</div>
					</div>
				</div> -->
				<div class="form-item" style="align-items: flex-start;">
					<div class="title" style="line-height: 45px;">
						<div style="width: 113px;"> 修改手机号：</div>
					</div>
					<div class="inp">
						<div style="display: flex;">
							<input type="text" v-model="form2.phone" :placeholder="getOriginal('phone')">
							<div style="margin-left: 30px;display: flex;align-items: ;">
								<span style="line-height: 45px;">验证码:</span>
								<input type="text" style="width: 100px;margin-left: 10px;" v-model="form2.phoneCode"
									placeholder="验证码">
								<p class="getCode" @click="send2" v-if="showtime2===null">获取手机验证码</p>
								<p v-else class="getCode"> {{showtime2}}</p>
								<span style="color: #0052D9;cursor: pointer;margin-left: 27px;line-height: 45px;"
									@click='editUMainMobile'>确认修改</span>
							</div>
						</div>
					</div>
				</div>
				<h3 style="margin-bottom: 30px;">备用联系方式<span
						style="color: #888;font-weight: normal;">(不可用于登录，仅用于密码找回)</span></h3>
				<div class="form-item" style="align-items: flex-start;">
					<div class="title" style="line-height: 45px;">
						<div style="width: 113px;"> 备用邮箱：</div>
					</div>
					<div class="inp">
						<div style="display: flex;">
							<input type="text" style=" width: 300px;" v-model="Backup[0].email" placeholder="请输入备用邮箱">
							<div style="margin-left: 30px;display: flex;align-items: ;">
								<span style="line-height: 45px;width: 120px;">确认备用邮箱:</span>
								<input type="text" @change="backupEmail" v-model="Backup[0].reEmail"
									style="width: 300px;margin-left: 10px;" placeholder="请重复输入">

								<span v-if="Backup[0].status == true"
									style="color: #0052D9;cursor: pointer;margin-left: 27px;line-height: 45px;">校验重复正确</span>
								<span v-if="Backup[0].status == false"
									style="color: red;cursor: pointer;margin-left: 27px;line-height: 45px;">校验重复错误</span>
							</div>
						</div>
					</div>
				</div>
				<div class="form-item" style="align-items: flex-start;">
					<div class="title" style="line-height: 45px;">
						<div style="width: 113px;"> 备用手机号：</div>
					</div>
					<div class="inp">
						<div style="display: flex;">
							<input type="text" style=" width: 300px;" v-model="Backup[1].phone" placeholder="请输入备用手机号">
							<div style="margin-left: 30px;display: flex;align-items: ;">
								<span style="line-height: 45px;width: 120px;">确认备用手机号:</span>
								<input type="text" @change="backupPhone" v-model="Backup[1].rePhone"
									style="width: 300px;margin-left: 10px;" placeholder="请重复输入">
								<span v-if="Backup[1].status == true"
									style="color: #0052D9;cursor: pointer;margin-left: 27px;line-height: 45px;">校验重复正确</span>
								<span v-if="Backup[1].status == false"
									style="color: red;cursor: pointer;margin-left: 27px;line-height: 45px;">校验重复错误</span>
							</div>
						</div>
					</div>
				</div>
				<div style="display: flex;justify-content: center;">
					<p style="margin-bottom: 30px;color: #0052d9;text-align: center;cursor: pointer;"
						@click="spareEmail">保存备用邮箱</p>
					<p style="height: 18px;width: 2px;margin: 0 10px;background-color: #0052d9;"></p>
					<p style="margin-bottom: 30px;color: #0052d9;text-align: center;cursor: pointer;"
						@click='spareMobile'>保存备用手机号</p>
				</div>
				<h3 style="margin-bottom: 30px;">注销账号<span style="color: #0052d9;font-weight: normal;">(谨慎操作)</span>
				</h3>
				<div class="form-item" style="align-items: flex-start;">
					<div class="title" style="line-height: 45px;width: 230px;">
						<div style=""> 请输入以下文字确认注销账户：</div>
					</div>
					<div class="inp" style="flex: 1;display: flex;">
						<input type="text" v-model.trim="zhuxiao" placeholder="我自愿注销账号所有数据即将删除!">
						<div class="byebye" @click="cancellation">确认注销账号！</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				logoff: '我自愿注销账号所有数据即将删除!',
				zhuxiao: '',
				userInfo: {},
				fileList: [],
				avatars: [],
				newPassword: '',
				reNewPassword: '',
				oldPassword: '',
				oldNickName: '',
				timeCounter: null,
				showtime: null,
				timeCounter2: null,
				showtime2: null,
				safeLevel: 25,
				safeTips: [],
				form2: {
					email: '',
					phone: '',
					emailCode: '',
					phoneCode: ''
				},
				Backup: [{
						email: '',
						reEmail: '',
						status: null,
					},
					{
						phone: '',
						rePhone: '',
						status: null,
					}
				]
			}
		},
		created() {
			this.accountInfo()
			this.systemAvatar()
			this.getUserNewInfo()
			
			if (this.$route.query.code) {
				this.bindWechat(this.$route.query.code)
			}
			console.log('阿里授权码：',this.$route.query.app_id)
			if (this.$route.query.app_id) {
				this.bindAli(this.$route.query.app_id)
			}
			
		},
		beforeDestroy() {
			this.getUserNewInfo()
		},
		watch: {

		},
		computed: {

			getSafeLevel() {
				let level = []
				let tips = []
				if (this.userInfo.reserve_email != null || this.userInfo.reserve_mobile != null) {
					const safe = this.safeTips.filter((contact) => contact !== '未设置备用联系方式');
					this.safeTips = safe
					level.push(1)
				} else {
					tips.push('未设置备用联系方式')
				}
				if (this.userInfo.email != "" && this.userInfo.mobile != "") {
					level.push(2)
				} else {
					tips.push('常用联系方式设置不完整')
				}
				if (this.userInfo.open_id != null&&this.userInfo.open_id != '') {
					level.push(3)
				} else {
					tips.push('未绑定微信号')
				}
				this.safeTips = [...new Map(tips.map(item => [item, item])).keys()]
				const uniqueArray = [...new Map(level.map(item => [item, item])).keys()];

				return uniqueArray.length + 1
			}
		},
		methods: {
			async delOpenId() {
				if (!this.userInfo.open_id) {
					this.$message({
						message: '暂无绑定的微信',
						type: 'warning'
					})
					return
				}
				const del = await this.$api.delWechatBind()
				if (del.code == 1) {
					this.$message({
						message: del.msg,
						type: 'success'
					})
				} else {
					this.$message({
						message: del.msg,
						type: 'warning'
					})
				}
			},
			async delAliId() {
				if (!this.userInfo.alipay_user_id) {
					this.$message({
						message: '暂无绑定的支付宝',
						type: 'warning'
					})
					return
				}
				const del = await this.$api.delAliBind()
				if (del.code == 1) {
					this.$message({
						message: del.msg,
						type: 'success'
					})
				} else {
					this.$message({
						message: del.msg,
						type: 'warning'
					})
				}
			},
			async bindWechat(code) {
				let log = await this.$api.getWechatCode({
					code: code
				})
				console.log(log.data);
				if (log.data.openid) {
					const bind = await this.$api.accountBindWechat({
						open_id: log.data.openid
					})
					if (bind.code == 1) {
						this.$message({
							message: bind.msg,
							type: 'success'
						})
					} else {
						this.$message({
							message: bind.msg,
							type: 'warning'
						})
					}
				}
			},
			async bindali(code) {
					console.log('阿里授权码：',code);
					const bind = await this.$api.accountBindAli({
						ali_id: code
					})
					if (bind.code == 1) {
						this.$message({
							message: bind.msg,
							type: 'success'
						})
						
					} else {
						this.$message({
							message: bind.msg,
							type: 'warning'
						})
					}

			},
			
			wechatLogin() {
				location.href =
					'https://open.weixin.qq.com/connect/qrconnect?appid=wx4658885ebd2e3204&redirect_uri=https%3a%2f%2fwww.zhaowaixie.com%2f%23%2fuserCenter%2faccountSet&response_type=code&scope=snsapi_login&state=3d6be0a4035d839573b04816624a415e#wechat_redirect'
			},
			aliLogin() {
				location.href =
					'https://auth.alipay.com/login/index.htm?goto=https%3A%2F%2Fopenauth.alipay.com%3A443%2Foauth2%2FpublicAppAuthorize.htm%3Fapp_id%3D2021004116690108%26scope%3Dauth_user%26redirect_uri%3Dhttps%3a%2f%2fwww.zhaowaixie.com%2f%23%2fuserCenter%2faccountSet'
			},
			async editUMainMobile() {
				const mobile = await this.$api.editUserMainMobile({
					mobile: this.form2.phone,
					captcha: this.form2.phoneCode
				})
				if (mobile.code == 1) {
					this.$message({
						message: mobile.msg,
						type: 'success'
					});
					this.userInfo.mobile = this.form2.phone
				} else {
					this.$message({
						message: mobile.msg,
						type: 'warning'
					});
				}
			},
			async accountInfo() {
				const info = await this.$api.getAccountInfo()
				this.userInfo = info.data
				this.oldNickName = this.userInfo.nickname
			},

			async editMainEmail() {
				const edit = await this.$api.editUserMainEmail({
					email: this.form2.email,
					captcha: this.form2.emailCode,
				})
				if (edit.code == 1) {
					this.$message({
						message: edit.msg,
						type: 'success'
					});
					this.userInfo.email = this.form2.email
				} else {
					this.$message({
						message: edit.msg,
						type: 'warning'
					});
				}
			},
			async editUserPassword() {
				if (this.oldPassword == '' || this.newPassword == '' || this.reNewPassword == '') {
					this.$message({
						message: '请将密码信息填写完整',
						type: 'warning'
					})
					return
				} else if (this.newPassword != this.reNewPassword) {
					this.$message({
						message: '确认密码不一致',
						type: 'warning'
					})
					return
				} else {
					const pass = await this.$api.editUserPassword({
						password: this.oldPassword,
						newpassword: this.newPassword
					})
					if (pass.code == 1) {
						this.$message({
							message: pass.msg,
							type: 'success'
						})
					} else {
						this.$message({
							message: pass.msg,
							type: 'warning'
						})
					}
				}

			},
			async getUserNewInfo() {
				const info = await this.$api.getUserNewInfo()
				info.data.userinfo.login = true
				this.$store.commit('SET_UserInfo', info.data.userinfo)
				sessionStorage.setItem('userInfo', JSON.stringify(info.data.userinfo));
			},
			async editNickname() {
				if (this.oldNickName == this.userInfo.nickname) return
				this.userInfo.nickname = this.oldNickName
				const status = await this.$api.editUserNickname({
					nickname: this.userInfo.nickname
				})
				if (status.code == 1) {
					this.$message({
						message: status.msg,
						type: 'success'
					})
				} else {
					this.$message({
						message: status.msg,
						type: 'warning'
					})
				}

			},
			async systemAvatar() {
				const avatars = await this.$api.getSystemAvatar()
				this.avatars = avatars.data
			},
			async uploadAvatar(xhr, file, fileList) {
				if (fileList.length > 1) {
					fileList.splice(0, 1);
				}
				if (xhr.code == 1) {
					await this.$api.editUserAvatar({
						avatar: xhr.data.url
					})
					this.userInfo.avatar = xhr.data.url
				}
			},
			// editSpareMobile 
			async spareEmail() {
				if (!this.Backup[0].status) {
					this.$message({
						message: '邮箱号不一致',
						type: 'warning'
					})
					return
				} else {
					const phone = await this.$api.editSpareEmail({
						reserve_email: this.Backup[0].email
					})
					if (phone.code == 1) {
						this.$message({
							message: phone.msg,
							type: 'success'
						})
						this.userInfo.reserve_email = this.Backup[0].email
					} else {
						this.$message({
							message: phone.msg,
							type: 'warning'
						})
					}
				}
			},
			async spareMobile() {
				if (!this.Backup[1].status) {
					this.$message({
						message: '手机号不一致',
						type: 'warning'
					})
					return
				} else {
					const phone = await this.$api.editSpareMobile({
						reserve_mobile: this.Backup[1].phone
					})
					if (phone.code == 1) {
						this.$message({
							message: phone.msg,
							type: 'success'
						})
						this.userInfo.reserve_mobile = this.Backup[1].phone
					} else {
						this.$message({
							message: phone.msg,
							type: 'warning'
						})
					}
				}
			},
			// editSpareMobile
			getOriginal(type) {
				let phone = this.userInfo.mobile
				let email = this.userInfo.email
				if (type == 'phone') {
					return phone == '' ? '暂未设置手机号' : '原手机号' + ':' + phone
				}
				if (type == 'email') {
					return email == '' ? '暂未设置邮箱' : '原邮箱' + ':' + email
				}
			},
			isDataString(str) {
				return str.slice(0, 4) === 'data';
			},
			async cancellation() {
				if (this.zhuxiao == this.logoff || this.zhuxiao == '我自愿注销账号所有数据即将删除') {
					const out = await this.$api.logoutAccount()
					if (out.code == 1) {
						this.$message({
							message: out.msg,
							type: 'warning'
						});
						this.$router.replace('/login')
					}
				} else {
					this.$message({
						message: '输入错误',
						type: 'warning'
					});
				}
			},
			backupEmail() {
				if (this.Backup[0].email == this.Backup[0].reEmail) {
					this.Backup[0].status = true
				} else {
					this.Backup[0].status = false
				}
			},
			backupPhone() {
				if (this.Backup[1].phone == this.Backup[1].rePhone) {
					this.Backup[1].status = true
				} else {
					this.Backup[1].status = false
				}
			},
			async changeAvatar(item) {
				if (this.userInfo.avatar == item.image) return
				this.userInfo.avatar = item.image
				await this.$api.editUserAvatar({
					avatar: this.userInfo.avatar
				})
			},
			countDownText(s) {
				this.showtime = `${s}s后重新获取`
			},
			// 倒计时 60秒 
			countDown(times) {
				const self = this;
				// 时间间隔 1秒
				const interval = 1000;
				let count = 0;
				self.timeCounter = setTimeout(countDownStart, interval);

				function countDownStart() {
					if (self.timeCounter == null) {
						return false;
					}
					count++
					self.countDownText(times - count + 1);
					if (count > times) {
						clearTimeout(self.timeCounter)
						self.showtime = null;
					} else {
						self.timeCounter = setTimeout(countDownStart, interval)
					}
				}
			},
			async send() {
				const emailRegex = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
				if (this.form2.email == '') {
					this.$message.error('请填写邮箱');
					return
				}
				if (emailRegex.test(this.form2.email)) {
					const email = await this.$api.sendEmailCode({
						event: 'changeemail',
						email: this.form2.email
					})
					if (email.code == 1) {
						this.$message({
							message: email.msg,
							type: 'success'
						});
						this.countDown(60);
					} else {
						this.$message({
							message: email.msg,
							type: 'warning'
						});
					}
				} else {
					this.$message.error('邮箱格式错误');
				}
			},
			countDownText2(s) {
				this.showtime2 = `${s}s后重新获取`
			},
			// 倒计时 60秒 
			countDown2(times) {
				const self = this;
				// 时间间隔 1秒
				const interval = 1000;
				let count = 0;
				self.timeCounter = setTimeout(countDownStart, interval);

				function countDownStart() {
					if (self.timeCounter == null) {
						return false;
					}
					count++
					self.countDownText2(times - count + 1);
					if (count > times) {
						clearTimeout(self.timeCounter)
						self.showtime2 = null;
					} else {
						self.timeCounter2 = setTimeout(countDownStart, interval)
					}
				}
			},
			async send2() {
				const phoneReg = /^1\d{10}$/;
				if (this.form2.phone == '') {
					this.$message.error('请填写手机号');
					return
				}
				if (phoneReg.test(this.form2.phone)) {
					const email = await this.$api.sendPhoneCode({
						mobile: this.form2.phone
					})
					if (email.code == 1) {
						this.$message({
							message: email.msg,
							type: 'success'
						});
						this.countDown2(60);
					}
				} else {
					this.$message.error('手机号格式错误');
				}
			},
		}
	}
</script>

<style scoped lang="less">
	.byebye {
		width: 255px;
		height: 45px;
		line-height: 45px;
		color: white;
		cursor: pointer;
		text-align: center;
		background: #313131;
		border: 1px solid #D2D2D2;
		margin-left: 10px;
	}

	.wechat {
		margin-left: 40px;

		&>div {
			margin-right: 30px;
			width: 156px;
			height: 48px;
			color: #0052D9;
			text-align: center;
			line-height: 48px;
			cursor: pointer;
			border: 1px solid #0052D9;
		}

		&>div:last-child {
			width: 156px;
			height: 48px;
			background: #EEEEEE;
			color: #888888;
			border: 1px solid #EEEEEE;
		}
	}

	.secureStatus {
		margin-top: 38px;
	}

	.getCode {
		width: 133px;
		height: 44px;
		border-radius: 5px;
		background: #0052D9;
		background: #0052D9;
		border: 1px solid #D2D2D2;
		color: white;
		line-height: 40px;
		text-align: center;
		cursor: pointer;
	}

	// .form-item {
	// 	display: flex;
	// 	margin-bottom: 30px;
	// 	align-items: baseline;

	// 	.inp {
	// 		margin-left: 20px;

	// 	}

	// 	.title {
	// 		font-size: 18px;
	// 		display: flex;
	// 		align-items: center;

	// 		&>div {
	// 			width: 113px;
	// 			text-align-last: justify;
	// 		}
	// 	}
	// }
	.form-item {
		width: 100%;
		display: flex;
		align-items: center;
		margin-bottom: 35px;

		& input {
			font-size: 18px;
			padding: 0 15px;
			box-sizing: border-box;
			width: 448px;
			height: 45px;
			border: 1px solid #D2D2D2;
			border-radius: 6px;
			margin-left: 40px;
		}

		.title {

			width: 114px;
			text-align: right;
			font-size: 16px;
		}
	}

	.Avatar {
		display: flex;

		.systeamAvatar {
			margin-left: 40px;
		}

		.userAvatar {
			display: flex;
			width: 120px;
			flex-wrap: wrap;
			justify-content: center;

			.upload {
				margin-top: 20px;
				width: 89px;
				height: 34px;
				background: #EEEEEE;
				line-height: 34px;
				text-align: center;
				cursor: pointer;
			}
		}
	}

	.body-mid {
		padding: 30px 0;
		margin: 0 20px;
		width: 1120px;
		box-sizing: border-box;
		background: #fff;
	}
</style>